import {
  ComputeRetentionMetricsRequest,
  QueryCacheOptions,
} from '@fullstory/proto/fs/services/alexa';
import { Duration } from '@fullstory/proto/google/protobuf';
import jstz from 'jstz';
import { RetentionMetricsRequestBody } from './types';

export const retentionMetricsRequestBodyToComputeRetentionMetricRequest = (
  body: RetentionMetricsRequestBody,
): ComputeRetentionMetricsRequest => ({
  orgId: body.orgId,
  computation: body.computation,
  now: null, // current time is implied
  timezone: jstz.determine().name(),
  cacheOptions: body.cacheOptions ?? null,
  sampleOptions: null,
  requestAnalytics: body.requestAnalytics ?? null,
});

const second = 1000;
const minute = 60 * second;
const hour = 60 * minute;

export const retentionCacheOptions: QueryCacheOptions = {
  getIfAgeLessThan: Duration.fromMillis(2 * hour),
  computeIfOlderThan: Duration.fromMillis(hour),
  skipCache: false,
  queue: QueryCacheOptions.Queue.QUEUE_INVALID,
};

// retentionCacheOptionsRefresh is query cache options to refresh data
// for retention metrics. The values match the most aggressive values that
// the server allows.
export const retentionCacheOptionsRefresh: QueryCacheOptions = {
  getIfAgeLessThan: Duration.fromMillis(5 * minute),
  computeIfOlderThan: Duration.fromMillis(minute),
  skipCache: false,
  queue: QueryCacheOptions.Queue.QUEUE_INVALID,
};
